export default __webpack_public_path__ + "static/media/g50-globe.cbe6eae9.svg";